import { MEDUSA_API_URL, MEDUSA_API_KEY } from './config';
import { attachDistributorPrices } from './distributor';
import { sortVariantsByPrice } from './sortVariants';

// Cliente para hacer peticiones a Medusa
async function medusaRequest(endpoint, options = {}) {
  const url = `${MEDUSA_API_URL}${endpoint}`;

  const response = await fetch(url, {
    ...options,
    // Default seguro: incluir cookies para que endpoints autenticados no pierdan la sesión
    // si un caller olvida pasar credentials. Los callers pueden sobreescribir con 'omit' u otro.
    credentials: options.credentials ?? 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-publishable-api-key': MEDUSA_API_KEY,
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`Medusa API error: ${response.status}`);
  }

  return response.json();
}

// Resolver handle de categoría a su ID en Medusa v2
async function getProductCategoryId(handle) {
  const data = await medusaRequest(`/store/product-categories?handle[]=${handle}`);
  return data.product_categories?.[0]?.id ?? null;
}

// Obtener productos con filtros opcionales server-side
// params: { tagIds?: string[], categoryHandle?: string }
export async function getProducts(params = {}) {
  const qs = new URLSearchParams();
  qs.set('fields', '*variants.prices,*categories,*images,+thumbnail,+metadata,+tags,+variants.manage_inventory,+variants.allow_backorder,+variants.inventory_quantity');
  qs.set('limit', '500');

  if (params.categoryHandle && params.categoryHandle !== 'todo') {
    const catId = await getProductCategoryId(params.categoryHandle);
    if (catId) qs.append('category_id[]', catId);
  }
  (params.tagIds || []).forEach(id => qs.append('tag_id[]', id));

  const data = await medusaRequest(`/store/products?${qs.toString()}`);
  await attachDistributorPrices(data.products);
  sortVariantsByPrice(data.products || []);
  return data.products;
}

// Obtener todas las categorías de productos con nombre, handle y descripción
export async function getProductCategories() {
  const data = await medusaRequest('/store/product-categories?fields=id,name,handle,description,metadata');
  return data.product_categories || [];
}

// Obtener un producto por handle (slug)
export async function getProductByHandle(handle) {
  const data = await medusaRequest(`/store/products?handle=${handle}&fields=*variants.prices,*categories,*images,+thumbnail,+metadata,+variants.manage_inventory,+variants.allow_backorder,+variants.inventory_quantity`);
  const products = data.products || [];
  await attachDistributorPrices(products);
  sortVariantsByPrice(products);
  return products[0];
}

// Obtener un producto por ID
export async function getProductById(id) {
  const data = await medusaRequest(`/store/products/${id}?fields=*variants.prices,*categories,*images,+thumbnail,+metadata,+variants.manage_inventory,+variants.allow_backorder,+variants.inventory_quantity`);
  if (data.product) {
    await attachDistributorPrices([data.product]);
    sortVariantsByPrice(data.product);
  }
  return data.product;
}
